import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

const ANGULAR_URL =
  process.env.REACT_APP_API_environment === 'LOCAL'
    ? 'http://localhost:4200'
    : process.env.REACT_APP_API_environment === 'STAGING'
      ? 'https://tnemis-staging.tnsed.com'
      : 'https://tnemis.tnschools.gov.in';

/**
 * Catch-all route: any path that doesn't match a defined React route
 * is assumed to belong to the Angular app and gets redirected there.
 *
 * This means devs can use normal `useNavigate()` with any path —
 * if it's a React route it renders normally, if not it lands here
 * and gets forwarded to Angular automatically.
 *
 * Safety: only redirects if user has a valid token (is logged in).
 * Without a token, the user should stay on the React login page.
 */
export default function DynamicPage() {
  const location = useLocation();

  useEffect(() => {
    const token = localStorage.getItem('token');

    // Only redirect to Angular if user is logged in.
    // If not logged in, they'll be caught by AppLayout's auth guard
    // and sent to login — no redirect to Angular needed.
    if (token) {
      window.location.href = `${ANGULAR_URL}${location.pathname}${location.search}`;
    }
  }, [location]);

  return (
    <div className="container mt-3 text-center py-5">
      <p className="text-muted">Redirecting...</p>
    </div>
  );
}
